<template>
  <div class="row q-pa-none q-ma-none">
    <div style="margin-left: 50%; transform: translateX(-50%)">
      <h6 style="margin: 3px 0px">Loading ... </h6>
      <q-spinner-bars
        size="sm"
        style="margin-left: 50%; transform: translateX(-50%)"
        class="iconColor"
      />
    </div>
  </div>
</template>

<script>
import { QSpinnerBars } from "quasar";
export default {
  components: {
   QSpinnerBars,
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/quasar.variables.scss";

.iconColor {
  color: $blueColor;
}
</style>
